export function TaskGroupHeader({ label, count }: { label: string; count: number }) {
  return (
    <div className="tp-group-header">
      <span className="tp-group-header__label">{label}</span>
      <span className="tp-group-header__count">({count})</span>
      <span className="tp-group-header__rule" />
    </div>
  );
}
